import withFinalForm from "@/hocs/withFinalForm";

/** Re-export Inputs */
export { default as Input } from "./Base/Input";
export { default as Radio } from "./Base/Radio";
export { default as Select } from "./Base/Select";
export { default as Textarea } from "./Base/Textarea";
export { default as Checkbox } from "./Field/Checkbox";
export { default as DateField } from "./Field/Date";
export { default as InputField } from "./Field/InputField";
export { default as PasswordField } from "./Field/PasswordField";
export { default as SelectField } from "./Field/SelectField";
export { default as Slider } from "./Field/Slider";

/** Import Input defaults to re-export with FinalForm */
import Input from "./Base/Input";
import Radio from "./Base/Radio";
import Select from "./Base/Select";
import Textarea from "./Base/Textarea";
import TokenizedInput from "./Base/TokenizedInput";
import Checkbox from "./Field/Checkbox";
import DateField from "./Field/Date";
import DateRangeField from "./Field/DateRange";
import InputField from "./Field/InputField";
import PasswordField from "./Field/PasswordField";
import SelectField from "./Field/SelectField";
import Slider from "./Field/Slider";
import SwitchToggle from "./Field/SwitchToggle";
import TextareaField from "./Field/TextareaField";
import TokenizedInputField from "./Field/TokenizedInputField";

/** Final Form Input exports */
export const FF_Checkbox = withFinalForm(Checkbox);
export const FF_Date = withFinalForm(DateField);
export const FF_DateRange = withFinalForm(DateRangeField);
export const FF_Input = withFinalForm(Input);
export const FF_Radio = withFinalForm(Radio);
export const FF_Select = withFinalForm(Select);
export const FF_Textarea = withFinalForm(Textarea);
export const FF_TextareaField = withFinalForm(TextareaField);
export const FF_InputField = withFinalForm(InputField);
export const FF_SelectField = withFinalForm(SelectField);
export const FF_PasswordField = withFinalForm(PasswordField);
export const FF_Slider = withFinalForm(Slider);
export const FF_SwitchToggle = withFinalForm(SwitchToggle);
export const FF_TokenizedInput = withFinalForm(TokenizedInput);
export const FF_TokenizedInputField = withFinalForm(TokenizedInputField);
